import { useSelector } from 'react-redux';

import * as routingSelectors from '@makemydeal/dr-dash-store/selectors/router';
import BaseDealFooterInterstate from '../baseDealFooter/Footer.interstate';
import { StickyFooter } from './Footer.style.interstate';

export const Footer = () => {
    const isDashboardCurrentRoute = useSelector(routingSelectors.isDashboardCurrentRoute);

    if (!isDashboardCurrentRoute) {
        return null;
    }
    return (
        <>
            <StickyFooter>{<BaseDealFooterInterstate />}</StickyFooter>
        </>
    );
};
